module.exports = __webpack_public_path__ + "static/media/avenir.575bd451.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avenir.ttf
// module id = 9426
// module chunks = 0